module.exports = __webpack_public_path__ + "images/assets/33653eb2fd09dbd1a5ffbe50a1e9f03f.svg";